import { getMonitoringMonth } from "./getMonitoringMonth";
import { postMonitoringMonth } from "./postMonitoringMonth";

export const monitoringMonthApi = {
  getMonitoringMonth,
  postMonitoringMonth
};
